import { values } from 'lodash'
import createActionSet from './actions.js'
import createReducer from './reducer.js'
import { persistDuck } from './persistence.js'

const ducks = {}
const getDocByName = {}
const getCollectionByName = {}

function createDuck(name, getDoc, getCollection, customActions, emptyDoc, customReducers = {}, opt = null) {
  getDocByName[name] = getDoc
  getCollectionByName[name] = getCollection
  
  const duck =  {
    actions: createActionSet(name, getDoc, getCollection, customActions || {}), 
    reducer: createReducer(name, emptyDoc, customReducers, opt || {})
  }

  ducks[name] = duck
  persistDuck(name, { extraCreateActions: opt.extraCreateActions })
  
  return duck
}

export function fetchAll(dispatch, name = null) {
  if (name) {
    dispatch(ducks[name].actions.fetchCollection())
  }
  else {
    values(ducks).forEach(duck => dispatch(duck.actions.fetchCollection()))
  }
}

export default createDuck
